import {
  ListItemLoadingPlaceholder,
} from '@sgcmpteltd/uikit-react/components/list-item-loading-placeholder';
import cx from 'clsx';

import styles from './styles.module.scss';
import type { Component, LoadingPlaceholderConfigList } from './types';

export const LoadingPlaceholderList: Component = ({
  className,
  itemContainerClassName,
  itemCount,
}) => {
  const loadingPlaceholderConfigList: LoadingPlaceholderConfigList = (
    Array(itemCount)
      .fill(null)
      .map((_, index) => ({
        key: `loading-placeholder-${index}`,
      }))
  );

  return (
    <ul
      className={cx(
        styles.containerRoot,
        className,
      )}>
      {
        loadingPlaceholderConfigList.map(({
          key,
        }) => (
          <li
            key={key}
            className={cx(
              styles.containerLoadingPlaceholderItem,
              itemContainerClassName,
            )}>
            <ListItemLoadingPlaceholder />
          </li>
        ))
      }
    </ul>
  );
};
